var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('section',{staticClass:"sizes-cfgs"},[_c('br'),_c('SizesTable'),_c('br'),_c('hr')],1),_c('section',{staticClass:"category-config"},[_c('br'),_c('CategoriesTable'),_c('br'),_c('hr')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }